import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import { useState, useRef } from 'react';
import useMount from 'react-use/lib/useMount';
import { toggleToast } from '../../toast/index.js';
import { THROTTLE_DELAY_MS } from './consts.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var DataCache = /*#__PURE__*/_createClass(function DataCache(initialData) {
  var _this = this;

  _classCallCheck(this, DataCache);

  _defineProperty(this, "updateData", function (data) {
    _this.data = data;
  });

  this.data = initialData;
});
var createUseThrottleRequest = function createUseThrottleRequest() {
  var toastError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  // 缓存上次请求时间戳和成功返回的数据
  var requestCache = new DataCache(); // 节流请求

  var useThrottleRequest = function useThrottleRequest(_ref) {
    var _requestCache$data, _requestCache$data2;

    var request = _ref.request,
        _ref$delay = _ref.delay,
        delay = _ref$delay === void 0 ? THROTTLE_DELAY_MS : _ref$delay;

    var _useState = useState({
      res: (_requestCache$data = requestCache.data) === null || _requestCache$data === void 0 ? void 0 : _requestCache$data.cache,
      success: true
    }),
        _useState2 = _slicedToArray(_useState, 2),
        data = _useState2[0],
        setData = _useState2[1];

    var _useState3 = useState(!!((_requestCache$data2 = requestCache.data) !== null && _requestCache$data2 !== void 0 && _requestCache$data2.loading)),
        _useState4 = _slicedToArray(_useState3, 2),
        loading = _useState4[0],
        setLoading = _useState4[1];

    var updateLoading = function updateLoading(loadingStatus) {
      setLoading(loadingStatus);
      requestCache.updateData(_objectSpread(_objectSpread({}, requestCache.data), {}, {
        loading: loadingStatus
      }));
    }; // TODO: 支持外部调用 retry


    var retry = function retry(params) {
      updateLoading(true);
      request(params).then(function (res) {
        setData({
          res: res,
          success: true
        }); // 数据更新成功后，更新节流时间戳

        requestCache.updateData({
          cache: res,
          loading: false,
          ts: Date.now()
        });
        setLoading(false);
      }).catch(function (err) {
        setData({
          res: err,
          success: false
        });
        updateLoading(false);

        if (toastError) {
          toggleToast(err.message || '未知错误');
        }
      });
    };

    useMount(function () {
      var _requestCache$data3;

      // 节流接口请求
      if (Date.now() - (((_requestCache$data3 = requestCache.data) === null || _requestCache$data3 === void 0 ? void 0 : _requestCache$data3.ts) || 0) > delay) {
        retry();
      }
    });
    return {
      data: data.res,
      success: data.success,
      loading: loading
    };
  };

  return useThrottleRequest;
};
var createUseMomizedScroll = function createUseMomizedScroll() {
  // 缓存滚动条滚动百分比位置
  var scrollCache = new DataCache(); // 重新定位上一次缓存滚动条的百分比位置

  var useMomizedScroll = function useMomizedScroll() {
    var scrollRef = useRef(null);

    var updateScrollPos = function updateScrollPos(pos) {
      scrollCache.updateData({
        pos: pos
      });
    };

    useMount(function () {
      var _scrollRef$current, _scrollCache$data;

      (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollToPos(((_scrollCache$data = scrollCache.data) === null || _scrollCache$data === void 0 ? void 0 : _scrollCache$data.pos) || 0);
    });
    return {
      updateScrollPos: updateScrollPos,
      scrollRef: scrollRef
    };
  };

  return useMomizedScroll;
};

export { DataCache, createUseMomizedScroll, createUseThrottleRequest };
